<template>
  <el-dialog
    title="门诊收费详情"
    width="60rem"
    top="4vh"
    :visible="visible"
    :close-on-click-modal="false"
    @open="init"
    @close="close"
  >
    <el-main
      style="padding: 0 2rem 0 2rem"
      :class="'正常' != entity.offsetFlag ? 'refund-border' : ''"
    >
      <el-descriptions v-if="reg" title="患者信息" :column="3">
        <el-descriptions-item label="姓名">{{
          reg.patientName
        }}</el-descriptions-item>
        <el-descriptions-item label="性别">{{
          reg.patientGender | dictText("Gender")
        }}</el-descriptions-item>
        <el-descriptions-item label="年龄">{{
          reg.patientAge
        }}</el-descriptions-item>
        <el-descriptions-item label="证件" v-if="reg.appCardType">{{
          reg.appCardType | dictText("IdType")
        }}</el-descriptions-item>
        <el-descriptions-item label="号码" v-if="reg.cardNo">{{
          reg.cardNo | mask
        }}</el-descriptions-item>
        <el-descriptions-item label="就诊类别">
          <el-tag
            v-if="Enum.OpType.医保工伤 == entity.opType"
            size="small"
            effect="plain"
            type="danger"
            >{{ entity.opType }}
          </el-tag>
          <el-tag
            v-else-if="Enum.OpType.医保 == entity.opType"
            size="small"
            effect="plain"
            type="warning"
            >{{ entity.opType }}
          </el-tag>
          <el-tag v-else size="small" effect="plain" type="success"
            >{{ entity.opType }}
          </el-tag>
          <el-tag
            v-if="entity.setlType"
            class="left-pad"
            size="small"
            effect="plain"
            type="info"
            >{{ entity.setlType }}
          </el-tag>
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions title="支付信息" :column="3" contentClassName="right">
        <el-descriptions-item label="费用合计">{{
          entity.feeAmount | fmtFloat(2)
        }}</el-descriptions-item>
        <el-descriptions-item label="基金支付">{{
          entity.feeFund | fmtFloat(2)
        }}</el-descriptions-item>
        <el-descriptions-item label="个人账户">{{
          entity.feeAccount | fmtFloat(2)
        }}</el-descriptions-item>
        <el-descriptions-item label="个人支付" content-style="color:red">{{
          entity.feeCash | fmtFloat(2)
        }}</el-descriptions-item>
        <el-descriptions-item label="发票金额">
          <span v-if="entity.opType === '医保' && entity.feeDiscount === 0">
            ￥{{ entity.feeAmount | fmtFloat(2) }}
          </span>
          <span v-else-if="entity.payWay === 'enterprise'"
            >￥{{ entity.feeAmount | fmtFloat(2) }}</span
          >
          <span v-else>￥{{ entity.feeCash | fmtFloat(2) }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="类型" content-style="color:orange">{{
          paymentState
        }}</el-descriptions-item>
        <el-descriptions-item label="支付方式" content-style="color:orange">{{
          entity.payWay | dictText("PayWay")
        }}</el-descriptions-item>

        <el-descriptions-item label="支付状态">
          <el-tag
            v-if="'已执行' == entity.state"
            type="success"
            size="small"
            effect="plain"
            >已支付</el-tag
          >
          <el-tag v-else type="danger" size="small" effect="plain"
            >未支付</el-tag
          >
          <el-tag
            v-if="'正常' != entity.offsetFlag"
            type="danger"
            size="small"
            effect="plain"
            class="left-pad"
            >已退款</el-tag
          >
        </el-descriptions-item>
        <el-descriptions-item label="流水号">{{
          entity.no
        }}</el-descriptions-item>
        <el-descriptions-item label="发票号">{{
          entity.invoiceNo
        }}</el-descriptions-item>
        <el-descriptions-item label="收费员">{{
          entity.operatorUserName
        }}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions
        title="费用分类"
        :column="3"
        contentClassName="right"
        :colon="false"
      >
        <el-descriptions-item v-for="key in Object.keys(feeTypeRes)" :key="key">
          {{ key | dictText("FeeType") }}：{{ feeTypeRes[key] | fmtFloat(2) }}
        </el-descriptions-item>
      </el-descriptions>
      <h3 style="text-align: left">单据详细</h3>
      <el-collapse>
        <el-collapse-item
          name="就诊号"
          title="医事服务费"
          v-if="reg && isRegCharge"
        >
          <div
            slot="title"
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 100%;
            "
          >
            <span>就诊号：</span>
            <el-tag
              v-if="reg"
              size="mini"
              class="right-pad no-border"
              effect="plain"
              style="float: right"
              >金额：<span class="red edit-thin">{{
                reg.price | fmtFloat(2)
              }}</span></el-tag
            >
          </div>
          <el-descriptions title="" :column="3" style="margin-left: 3rem">
            <el-descriptions-item label="编号">{{
              reg.opNo
            }}</el-descriptions-item>
            <el-descriptions-item label="号别"
              ><span style="color: blue">{{
                reg.regType | dictText("RegType")
              }}</span></el-descriptions-item
            >
            <el-descriptions-item label="科室">{{
              reg.deptCode | dictText("Dept")
            }}</el-descriptions-item>
            <el-descriptions-item label="日期">{{
              reg.date
            }}</el-descriptions-item>
            <el-descriptions-item label="午别">{{
              reg.periodType
            }}</el-descriptions-item>
            <el-descriptions-item label="序号">{{
              reg.seqNo
            }}</el-descriptions-item>
            <el-descriptions-item label="医师">{{
              reg.doctorName
            }}</el-descriptions-item>
            <el-descriptions-item label="费用"
              >￥{{ entity.feeAmount | fmtFloat(2) }}</el-descriptions-item
            >
            <el-descriptions-item label="自付" content-style="color:red"
              >￥{{ entity.feeCash | fmtFloat(2) }}</el-descriptions-item
            >
            <el-descriptions-item label="状态"
              ><span style="color: blue">{{
                reg.state
              }}</span></el-descriptions-item
            >
          </el-descriptions>
        </el-collapse-item>
        <el-collapse-item
          name="药品"
          title="药品处方"
          v-if="amount(receipt.drugRps) > 0"
        >
          <div
            slot="title"
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 100%;
            "
          >
            <span
              >药品处方：<el-tag
                v-if="countDisabled(receipt.drugRps)"
                type="danger"
                size="mini"
                hit
                >退</el-tag
              ></span
            >
            <el-tag
              v-if="receipt.drugRps"
              type="info"
              size="mini"
              class="right-pad no-border"
              effect="plain"
              style="float: right"
              >数量：{{ count(receipt.drugRps) }} ， 金额：<span
                class="red edit-thin"
                >{{ amount(receipt.drugRps) | fmtFloat(2) }}</span
              ></el-tag
            >
          </div>
          <rp-card
            v-for="rp in receipt.drugRps"
            :key="rp.id"
            :rp="rp"
            hide-check-box
            :details="receipt.drugDetails.filter((d) => d.rpNo == rp.no)"
          ></rp-card>
        </el-collapse-item>
        <el-collapse-item
          name="草药"
          title="中药处方"
          v-if="amount(receipt.herbalRps) > 0"
        >
          <div
            slot="title"
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 100%;
            "
          >
            <span
              >中药处方：<el-tag
                v-if="countDisabled(receipt.herbalRps)"
                type="danger"
                size="mini"
                hit
                >退</el-tag
              ></span
            >
            <el-tag
              v-if="receipt.herbalRps"
              type="info"
              size="mini"
              class="right-pad no-border"
              effect="plain"
              style="float: right"
              >数量：{{ count(receipt.herbalRps) }} ， 金额：<span
                class="red"
                >{{ amount(receipt.herbalRps) | fmtFloat(2) }}</span
              ></el-tag
            >
          </div>
          <rp-card
            v-for="rp in receipt.herbalRps"
            :key="rp.id"
            :rp="rp"
            hide-check-box
            :details="receipt.herbalDetails.filter((d) => d.rpNo == rp.no)"
          ></rp-card>
        </el-collapse-item>
        <el-collapse-item
          name="检验申请单"
          title="检验申请单"
          v-if="count(receipt.mlApps) > 0"
        >
          <div
            slot="title"
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 100%;
            "
          >
            <span
              >检验申请单：<el-tag
                v-if="countDisabled(receipt.mlApps)"
                type="danger"
                size="mini"
                hit
                >退</el-tag
              ></span
            >
            <el-tag
              type="info"
              v-if="receipt.mlApps"
              size="mini"
              class="right-pad no-border"
              effect="plain"
              style="float: right"
              >数量：{{ count(receipt.mlApps) }} ， 金额：<span class="red">{{
                amount(receipt.mlApps) | fmtFloat(2)
              }}</span></el-tag
            >
          </div>
          <ml-card
            v-for="rp in receipt.mlApps"
            :key="rp.id"
            :ml="rp"
            hide-check-box
            :details="receipt.mlDetails.filter((d) => d.appNo == rp.no)"
          ></ml-card>
        </el-collapse-item>
        <el-collapse-item
          name="检查申请单"
          title="检查申请单"
          v-if="count(receipt.miApps) > 0"
        >
          <div
            slot="title"
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 100%;
            "
          >
            <span
              >检查申请单：<el-tag
                v-if="countDisabled(receipt.miApps)"
                type="danger"
                size="mini"
                hit
                >退</el-tag
              ></span
            >
            <el-tag
              type="info"
              v-if="receipt.miApps"
              size="mini"
              class="right-pad no-border"
              effect="plain"
              style="float: right"
              >数量：{{ count(receipt.miApps) }} ， 金额：<span class="red">{{
                amount(receipt.miApps) | fmtFloat(2)
              }}</span></el-tag
            >
          </div>
          <ml-card
            v-for="rp in receipt.miApps"
            :key="rp.id"
            :ml="rp"
            hide-check-box
            :details="receipt.miDetails.filter((d) => d.appNo == rp.no)"
          ></ml-card>
        </el-collapse-item>
        <el-collapse-item
          name="治疗申请单"
          title="治疗申请单"
          v-if="amount(receipt.therapyApps) > 0"
        >
          <div
            slot="title"
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 100%;
            "
          >
            <span
              >治疗申请单：<el-tag
                v-if="countDisabled(receipt.therapyApps)"
                type="danger"
                size="mini"
                hit
                >退</el-tag
              ></span
            >
            <el-tag
              type="info"
              v-if="receipt.therapyApps"
              size="mini"
              class="right-pad no-border"
              effect="plain"
              style="float: right"
              >数量：{{ count(receipt.therapyApps) }} ， 金额：<span
                class="red"
                >{{ amount(receipt.therapyApps) | fmtFloat(2) }}</span
              ></el-tag
            >
          </div>
          <therapy-card
            v-for="app in receipt.therapyApps"
            :key="app.id"
            :rp="app"
            hide-check-box
            :details="receipt.therapyDetails.filter((d) => d.appNo == app.no)"
          ></therapy-card>
        </el-collapse-item>
      </el-collapse>
    </el-main>
    <el-row type="flex" justify="end" align="middle" slot="footer">
      <small v-if="invoiceNo">当前发票号：{{ invoiceNo }}</small>
      <el-button
        v-if="invoiceNo"
        type="info"
        icon="el-icon-printer"
        size="small"
        class="left-pad"
        @click="close"
        >发票</el-button
      >

      <el-button
        class="left-pad"
        type="primary"
        size="small"
        @click="changePayway()"
        v-if="permission.registration_charge_paywayUpdate && payStep === 100"
      >
        修改支付方式
      </el-button>
      <el-button
        class="left-pad"
        type="primary"
        size="small"
        @click="finishChangePayway()"
        v-if="permission.registration_charge_paywayUpdate && payStep === 120"
      >
        确定修改
      </el-button>
      <el-button
        class="left-pad"
        type="primary"
        size="small"
        @click="cashPay()"
        v-if="paymentState === '医保已支付' && payStep === 100"
      >
        现金结算
      </el-button>
      <el-button
        class="left-pad"
        type="primary"
        size="small"
        @click="finishCashPay()"
        v-if="payStep === 220"
      >
        确定结算
      </el-button>
      <div
        class="left-pad payway-select-btn"
        v-if="payStep === 110 || payStep === 210"
      >
        <span>支付方式&nbsp;</span>
        <el-select
          placeholder="请选择名称"
          v-model="entity.payWay"
          auto-first="false"
          class="edit-input"
          size="small"
          style="width: 140px"
        >
          <el-option
            v-for="item in payWayOptions"
            :key="item.code"
            :label="item.text"
            :value="item.code"
            :disabled="item.disabled"
            @click.native="paywaySeleted({ code: item.code, label: item.text })"
          />
        </el-select>
      </div>
      <el-button
        type="info"
        icon="el-icon-printer"
        size="small"
        class="left-pad"
        @click="settlPrint"
        v-if="Enum.OpType.医保 == entity.opType"
      >
        医保结算打印
      </el-button>
      <!--退费的不显示凭证按钮 -->
      <el-button
        type="info"
        icon="el-icon-printer"
        size="small"
        class="left-pad"
        @click="chargeVoucher(false)"
        v-if="entity.offsetFlag === '正常'"
      >
        凭证
      </el-button>
      <!--退费的不显示，没有处方、申请单也不显示 -->
      <el-button
        type="info"
        icon="el-icon-printer"
        size="small"
        class="left-pad"
        @click="chargeVoucher(true)"
        v-show="
          entity.offsetFlag === '正常' &&
          (amount(receipt.drugRps) > 0 ||
            amount(receipt.herbalRps) > 0 ||
            count(receipt.mlApps) > 0 ||
            count(receipt.miApps) > 0 ||
            amount(receipt.therapyApps) > 0)
        "
      >
        打印明细
      </el-button>
      <el-button
        v-if="permission.registration_charge_refund && needRefund"
        type="danger"
        @click="refund"
        icon="el-icon-delete"
        size="small"
        >退款</el-button
      >
      <el-button type="default" @click="close" size="small">关 闭</el-button>
    </el-row>
    <refund
      :visible.sync="showRefund"
      :pay-entity="entity"
      @ok="refunded"
    ></refund>
    <settlPrint ref="settlPrint" @preview="preViewSettl"></settlPrint>
    <printDetail
      ref="printDetail"
      :propData="printDetailData"
      v-if="printDetailVisible"
    />
  </el-dialog>
</template>

<script>
import api from "./api";
import commonApi from "@/common/api";
import print from "@/common/print.js";
import { mapGetters } from "vuex";
export default {
  components: {
    "rp-card": () => import("./_rp"),
    "ml-card": () => import("./_ml"),
    "therapy-card": () => import("./_therapy"),
    refund: () => import("@/components/fee/refund"),
    settlPrint: () => import("./settlPrint"),
    printDetail: () => import("./printDetail"),
  },
  props: {
    visible: Boolean,
    entity: Object,
  },
  data() {
    return {
      receipt: {},
      reg: null,
      payInfo: null,
      invoiceNo: null,
      showRefund: false,
      printDetailVisible: false,
      printDetailData: null,
      unitMap: {},
      paymentState: null,
      payStep: 100,
      newPayWay: null,
      newPayCode: null,
      err: null,
    };
  },
  created() {
    this.loadUnitDict();
  },
  computed: {
    ...mapGetters(["permission", "Enum", "user", "dict"]),
    payWayOptions() {
      const options = this.$utils.clone(this.dict.PayWay);
      options.forEach((item) => {
        if (item.code === "enterprise") {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
      });
      return options;
    },
    feeTypeRes() {
      if (this?.entity?.divideRes) {
        return JSON.parse(this.entity.divideRes);
      }
      return [];
    },
    isRegCharge() {
      if (
        !this.receipt ||
        !this.receipt.regs ||
        !this.receipt.drugRps ||
        !this.receipt.herbalRps ||
        !this.receipt.mlApps ||
        !this.receipt.miApps ||
        !this.receipt.therapyApps
      ) {
        return false;
      }
      return (
        this.receipt?.regs.length == 1 &&
        !this.receipt?.drugRps.length &&
        !this.receipt?.herbalRps.length &&
        !this.receipt?.mlApps.length &&
        !this.receipt?.miApps.length &&
        !this.receipt?.therapyApps.length
      );
    },
    needRefund() {
      if (this?.entity?.offsetFlag != this.Enum.OffsetFlag.正常) {
        return false;
      }
      return (
        (this.receipt?.drugRps ?? []).some((r) => r.disabled) ||
        (this.receipt?.herbalRps ?? []).some((r) => r.disabled) ||
        (this.receipt?.mlApps ?? []).some((r) => r.disabled) ||
        (this.receipt?.miApps ?? []).some((r) => r.disabled) ||
        (this.receipt?.therapyApps ?? []).some((r) => r.disabled)
      );
    },
    isRefund() {
      if (!this?.entity?.insuranceSerialNo) return true;
      return !(
        (this.receipt?.drugRps ?? []).some((r) => !r.disabled) ||
        (this.receipt?.herbalRps ?? []).some((r) => !r.disabled) ||
        (this.receipt?.mlApps ?? []).some((r) => !r.disabled) ||
        (this.receipt?.miApps ?? []).some((r) => !r.disabled) ||
        (this.receipt?.therapyApps ?? []).some((r) => !r.disabled)
      );
    },
  },
  methods: {
    async init() {
      console.log("init:", this.entity);
      this.initPayStep();
      this.paymentState = this.entity.type;
      this.receipt = {};
      this.reg = null;
      let dividePara = null;
      if (this.entity.offsetFlag == this.Enum.OffsetFlag.正常) {
        this.receipt = await api.rfdQueryPaid(this.entity.id);
        this.reg = this.receipt.regs[0];
        return;
      } else if (this.entity.offsetFlag == this.Enum.OffsetFlag.冲单) {
        let res = await api.getOpPayment(this.entity.id);
        if (res.dividePara) {
          dividePara = JSON.parse(res.dividePara);
        }
      } else {
        let res = await api.queryOpPayment({ idOrigin: this.entity.id });
        if (res?.items.length && res.items[0].dividePara) {
          dividePara = JSON.parse(res.items[0].dividePara);
        }
      }
      if (dividePara?.receipt) {
        this.receipt = JSON.parse(dividePara?.receipt);
        this.reg = this.receipt.regs[0];
      }
      if (!this.receipt.regs) {
        this.receipt = { regs: [this.entity] };
        this.reg = this.receipt.regs[0];
      }
    },
    initPayStep() {
      this.payStep = 100;
      //现金支付：100-->210-->220
      //修改支付方式：100-->110-->120
    },
    loadUnitDict() {
      commonApi.queryDict("Unit").then((res) => {
        this.unitMap = res.items.reduce((a, b) => {
          a[b.code] = b.text;
          return a;
        }, {});
      });
    },
    count(items) {
      if (!items || !items.length) {
        return 0;
      }
      return items.length;
    },
    amount(items) {
      if (!items || !items.length) {
        return 0;
      }
      return items.reduce((a, b) => a + b.price, 0);

      // return items.reduce((a, b) => a + b.price * (b.quantity || 1), 0);
    },
    countDisabled(items) {
      if (!items || !items.length) {
        return 0;
      }
      return items.filter((i) => i.disabled).length;
    },
    close() {
      this.$emit("update:visible", false);
    },
    changePayway() {
      this.payStep = 110;
    },
    cashPay() {
      this.payStep = 210;
    },
    finishChangePayway() {
      api
        .updatePayWay({
          paymentId: this.entity.id,
          payway: this.newPayCode,
        })
        .then((res) => {
          this.entity.payWay = this.newPayWay;
          this.$emit("paid");
        })
        .catch((err) => {
          if (err.message) {
            this.showErr("修改支付方式失败！", err.message);
          }
        })
        .finally(() => {
          this.initPayStep();
        });
    },
    finishCashPay() {
      if (!this.entity || !this.entity.id) {
        return;
      }
      if (this.paying) {
        return;
      }
      this.paying = true;
      api
        .updatePayWay({
          paymentId: this.entity.id,
          payway: this.newPayCode,
        })
        .then((res) => {
          this.entity.payWay = this.newPayWay;

          api.finishCashPay(this.entity.id).then((res) => {
            this.paying = false;
            this.paymentState = "收费";
            this.$message.success("结算成功!");
            this.$emit("paid");
          });
        })
        .catch((err) => {
          if (err.message) {
            this.showErr("支付失败！", err.message);
          }
        })
        .finally(() => {
          this.initPayStep();
        });
    },
    paywaySeleted(val) {
      console.log(val);
      this.newPayWay = val.label;
      this.newPayCode = val.code;
      this.payStep = this.payStep + 10;
    },

    refund() {
      if (!this.needRefund) {
        this.$message.error("未找到需要退款的单据！");
        return;
      }
      if (!this.isRefund) {
        this.$message.error(
          "医保结算单据不能执行部分退款，请联系医生申请退款！"
        );
        return;
      }

      this.$nextTick(() => {
        this.showRefund = true;
      });
    },
    refunded() {
      this.$emit("refunded");
      this.$emit("update:visible", false);
    },
    showErr(tip, err) {
      this.err = `${tip}。${err.message || err}`;
      this.$message.error(this.err);
    },
    // 打印， isA4是否是打印详情
    chargeVoucher(isA4 = false) {
      const template = this.dict.PrintTemplate.find(
        (t) => t.code === "ChargeReceipt"
      );
      const { entity } = this;
      let cardNo = "";
      const dividePara =
        entity && entity.dividePara ? JSON.parse(entity.dividePara) : null;
      const patientInfo =
        dividePara && dividePara.regs ? dividePara.regs[0] : null;
      if (patientInfo) {
        cardNo = patientInfo.cardNo;
      }
      if (!template) {
        this.$message.error("未配置打印模板！");
        return;
      }
      // console.log(1133, this.entity, 'reg=', this.reg);
      const {
        patientName,
        no,
        payWay,
        feeAmount,
        feeFund,
        feeCash,
        operatorUserId,
        feeDiscount,
        // opType,
      } = entity;

      const { fmtFloat, dictText } = this.$utils;
      function formatFloat(val) {
        return fmtFloat(val, 2);
      }
      //修改医保类型
      let opType = dictText(entity.insutype, "InsuranceType");
      if (!opType) {
        opType = entity.opType;
      }

      const opNo =
        Array.isArray(dividePara.details) && dividePara.details[0]
          ? dividePara.details[0].opNo
          : "";
      const data = {
        patientName, // 姓名
        cardNo,
        opType, // 患者费别
        no,
        paymentType: dictText(payWay, "PayWay"), // 支付方式
        amount: formatFloat(feeAmount), // 费用合计
        insurance: formatFloat(0), // 医保内，新接口的数据里已经没有insurance字段，暂时显示为0。this.$utils.fmtFloat(this.entity.insurance, 2),
        accountPayments: formatFloat(feeFund), // 基金支付
        payment: formatFloat(feeCash), // 个人支付
        reg: this.isRegCharge ? this.reg : null,
        items: [],
        operatorUserId, // 收费员
        opNo,
        // 以下5个字段为了printDetail.vue
        receipt: this.receipt,
        patientAge: this.reg?.patientAge,
        takingDate: this.reg?.takingDate || "",
        patientGender: this.reg?.patientGender,
        doctorName: this.reg?.doctorName,
        operatorUserName: entity.operatorUserName,
        // reg: this.isRegCharge ? this.reg : null,
        // hospitalName: this.user.tenantName + "收费凭条",
      };
      const nos = dividePara.rps
        .filter((rp) => rp.rpClass !== "就诊号")
        .map((m) => m.no);
      // console.log(2323, nos, JSON.parse(JSON.stringify(dividePara.details)));
      if (nos && nos.length) {
        const { herbalRps } = this.receipt;
        data.items = dividePara.details.map((d) => {
          // 如果是“草药”并且有 中药处方 herbalRps
          if (
            d.rpClass === "草药" &&
            Array.isArray(herbalRps) &&
            herbalRps.length > 0
          ) {
            d.rpQuantity =
              herbalRps.find((h) => h.no === d.rpNo)?.quantity || 1; // 剂数
          }
          return d;
        });
        data.items = dividePara.details;
        console.log("打印参数=", entity, data, data.receipt);
        this.printFn(data, template, isA4);
      } else {
        this.printFn(data, template, isA4);
      }
    },
    printFn(data, template, isA4) {
      if (isA4) {
        // 客户反馈打印的单位数据有问题
        const {
          herbalDetails,
          drugDetails,
          miDetails,
          mlDetails,
          therapyDetails,
        } = data.receipt || {};
        [
          herbalDetails,
          drugDetails,
          miDetails,
          mlDetails,
          therapyDetails,
        ].forEach((items) => {
          if (!items) return;
          items.forEach((item) => {
            if (item.unit) {
              item.unit = this.unitMap[item.unit] || item.unit;
            }
          });
        });
        this.printDetailData = data;
        this.printDetailVisible = true;
      } else {
        // 客户反馈打印的单位数据有问题
        data.items.forEach((item) => {
          if (item.unit) {
            item.unit = this.unitMap[item.unit] || item.unit;
          }
        });
        print.chargeReceipt(data, template.content);
      }
    },
    settlPrint() {
      this.$refs.settlPrint.getSettlInfo(this.entity);
    },
    preViewSettl() {
      const htm = this.$refs.settlPrint.$el.innerHTML;
      print.statementTable(htm);
    },
  },
};
</script>
<style scoped>
.payway-select-btn {
  display: flex;
  align-items: center;
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  border-radius: 2px;
  margin-left: 10px;
  padding: 0 1px 0 6px;
  font-size: 12px;
  border-radius: 3px;
}
</style>
